import { SkeletonLoader } from "@via/components/loading/loading.tsx";
import { useUploadGoogleCredentialsFile } from "@via/pages/account/profile/profile.api.tsx";
import { credentialOptions } from "@via/utils/form-validators.tsx";
import React, { JSX } from "react";

export default function GoogleCredentialsForm({
  register,
  errors,
  setValue,
}): JSX.Element {
  const {
    mutateAsync: uploadFile,
    isPending: isUploadFileLoading,
    isSuccess: isUploadFileSuccess,
  } = useUploadGoogleCredentialsFile();

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const fileUploadResponse = await uploadFile(file);
      setValue("googleCredentials.keyName", fileUploadResponse?.keyName || "");
    }
  };

  return (
    <>
      <div className="space-y-5 pb-5">
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Credential Name <span className="text-red-400">*</span>
          </label>
          <div className="mt-2">
            <input
              data-testid="googleNameInput"
              {...register(
                "googleCredentials.name",
                credentialOptions.googleCredentials.name
              )}
              type="text"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder="Enter Your Credential Name"
            />
            {errors.googleCredentials?.name && (
              <span className="text-xs text-rose-500">
                {errors.googleCredentials.name.message}
              </span>
            )}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Project Id <span className="text-red-400">*</span>
          </label>
          <div className="mt-2">
            <input
              data-testid="googleProjectIdInput"
              {...register(
                "googleCredentials.projectId",
                credentialOptions.googleCredentials.projectId
              )}
              type="text"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder="Enter Your Project Id"
            />
            {errors.googleCredentials?.projectId && (
              <span className="text-xs text-rose-500">
                {errors.googleCredentials.projectId.message}
              </span>
            )}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Service Account Key <span className="text-red-400">*</span>
          </label>
          <div className="mt-2">
            <input
              data-testid="googleFileInput"
              type="file"
              className="block w-full rounded-lg border border-gray-200 border-neutral-700 text-sm text-neutral-400 shadow-sm file:me-4 file:border-0 file:bg-gray-50 file:px-4 file:py-3
              focus:z-10 focus:border-blue-500
              focus:ring-blue-500
              disabled:pointer-events-none disabled:opacity-50"
              onChange={handleFileUpload}
            />
            {errors.googleCredentials?.keyName ? (
              <span className="text-xs text-rose-500">
                {errors.googleCredentials.keyName.message}
              </span>
            ) : isUploadFileSuccess ? (
              <span className="text-xs">File is uploaded</span>
            ) : null}
            <input
              {...register(
                "googleCredentials.keyName",
                credentialOptions.googleCredentials.keyName
              )}
              type="text"
              className={"invisible"}
            />
            {isUploadFileLoading ? <SkeletonLoader count={1} /> : null}
          </div>
        </div>
      </div>
    </>
  );
}
